module.exports = __webpack_public_path__ + "img/skin-stroke.33230ba8.png";